import { msg } from "@lingui/macro";

export const RELATIVE_TIME_OPTIONS = [
  { label: msg`Personalizado`, value: 'absolute', numericValue: 0 },
  { label: msg`Últimos 15 minutos`, value: '-15m', numericValue: -15 * 60 * 1000 },
  { label: msg`Última hora`, value: '-1h', numericValue: -1 * 60 * 60 * 1000 },
  { label: msg`Últimas 4 horas`, value: '-4h', numericValue: -4 * 60 * 60 * 1000 },
  { label: msg`Últimas 8 horas`, value: '-8h', numericValue: -8 * 60 * 60 * 1000 },
  { label: msg`Últimas 12 horas`, value: '-12h', numericValue: -12 * 60 * 60 * 1000 },
  { label: msg`Último día`, value: '-1d', numericValue: -24 * 60 * 60 * 1000 },
  { label: msg`Últimos 3 días`, value: '-3d', numericValue: -3 * 24 * 60 * 60 * 1000 },
  { label: msg`Últimos 7 días`, value: '-7d', numericValue: -7 * 24 * 60 * 60 * 1000 },
  { label: msg`Últimos 10 días`, value: '-10d', numericValue: -10 * 24 * 60 * 60 * 1000 },
  { label: msg`Últimos 15 días`, value: '-15d', numericValue: -15 * 24 * 60 * 60 * 1000 },
  { label: msg`Últimos 30 días`, value: '-30d', numericValue: -30 * 24 * 60 * 60 * 1000 },
  { label: msg`Últimos 60 días`, value: '-60d', numericValue: -60 * 24 * 60 * 60 * 1000 },
  { label: msg`Últimos 90 días`, value: '-90d', numericValue: -90 * 24 * 60 * 60 * 1000 },
];

export const WINDOW_RANGES = [
  { max: 12 * 60 * 60 * 1000, window: null },
  { max: 1 * 24 * 60 * 60 * 1000, window: '15m' },
  { max: 3 * 24 * 60 * 60 * 1000, window: '30m' },
  { max: 7 * 24 * 60 * 60 * 1000, window: '1h' },
  { max: 15 * 24 * 60 * 60 * 1000, window: '6h' },
  { max: 60 * 24 * 60 * 60 * 1000, window: '12h' },
  { max: 90 * 24 * 60 * 60 * 1000, window: '1d' },
  { max: Infinity, window: '3d' },
];
